'use client';

import { useTranslation } from '@/features/i18n';
import { Input } from '@/ui/form/Input';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useState } from 'react';

type Props = {
  onSearchChange: (search: string) => void;
};

export const SearchBar = ({ onSearchChange }: Props) => {
  const { t } = useTranslation();
  // capture input change
  const [search, setSearch] = useState('');

  // capture input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newSearch = e.target.value;
    setSearch(newSearch);
    onSearchChange(newSearch);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSearchChange(search);
  };

  return (
    <form onSubmit={handleSubmit}>
      <label className="sr-only mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {t('search.what-do-you-want-to-watch')}
      </label>
      <div className="relative">
        <div className="text-text-input pointer-events-none absolute inset-y-0 start-0 flex items-center ps-3">
          <MagnifyingGlassIcon className="h-4 w-4" />
        </div>

        <Input
          type="search"
          id="default-search"
          placeholder={t('search.what-do-you-want-to-watch')}
          autoFocus
          required
          value={search}
          onChange={handleSearchChange}
        />
      </div>
    </form>
  );
};
